export var ButtonPurpose;
(function (ButtonPurpose) {
    ButtonPurpose["Danger"] = "btn-danger";
    ButtonPurpose["Info"] = "btn-info";
    ButtonPurpose["Primary"] = "btn-primary";
    ButtonPurpose["Secondary"] = "btn-secondary";
    ButtonPurpose["Tertiary"] = "btn-tertiary";
    ButtonPurpose["Icon"] = "btn-icon";
    ButtonPurpose["Success"] = "btn-success";
    ButtonPurpose["Warning"] = "btn-warning";
})(ButtonPurpose || (ButtonPurpose = {}));
